// extracted by mini-css-extract-plugin
export default {"normal":"styles__normal__WzPtP","danger":"styles__danger__WgvrL","gray":"styles__gray__Z8W8A","warning":"styles__warning__qpLx1"};